import { cloneDeep } from 'lodash';
import React from 'react';
import { assign } from 'xstate';

import { MachineContext } from '../../MachineContext';
import { BaseComponent } from '../Component';

import styles from './ThreeDots.module.css';

export interface ThreeDotsComponent extends BaseComponent {
  type: 'threeDots';
  props: Record<string, any>;
}

export const ThreeDots: React.FC = () => {
  return (
    <div className={styles['dot-container']}>
      <div className={styles['dot-elastic']}></div>
    </div>
  );
};

//
// render..Action is called by state machine in chatbot to push the control on
// the satack of elements to be rendered
//
export const renderThreeDots = assign(
  (context: MachineContext, _event, _actionMetadata) => {
    const newContext = cloneDeep(context);
    newContext.widgetData = newContext.widgetData.filter(
      (element) => !element.temporary
    );

    newContext.widgetData.push({
      type: 'threeDots',
      temporary: true,
      props: {},
    });

    return newContext;
  }
);
